import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { PreventiveCareNotice } from "@/Common/Api/PreventiveCare/Dto/Responses/PreventiveCareNotice";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { PreventiveCareNoticeLetterTypeEnum } from "@/Common/Models/PreventiveCare/PreventiveCareNoticeLetterTypeEnum";
import { PreventiveRecallTab } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { CorrespondenceHistoryItem } from "./CorrespondenceHistoryItem";

import styles from "./CorrespondenceHistory.module.scss";

interface ICorrespondenceHistoryProps {
    preventiveCareNotices: PreventiveCareNotice[];
}

function CorrespondenceHistory(props: ICorrespondenceHistoryProps): JSX.Element {
    const { getText } = useTranslation();

    function getCurrentPreventiveCareNoticeLabel(currentType: PreventiveCareNoticeLetterTypeEnum): string {
        switch (currentType) {
            case PreventiveCareNoticeLetterTypeEnum.FirstLetter:
                return getText("RecallList_PreventiveCareNoticeType_FirstLetter");
            case PreventiveCareNoticeLetterTypeEnum.SecondLetter:
                return getText("RecallList_PreventiveCareNoticeType_SecondLetter");
            case PreventiveCareNoticeLetterTypeEnum.PhoneCall:
                return getText("RecallList_PreventiveCareNoticeType_PhoneCall");
            default:
                return "";
        }
    }

    return (
        <div>
            <div className="myle-page-header bottom-border">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 margin-md-left">
                        <h3 className="thin-font flex-display">
                            {getText("PreventiveCareCorrespondenceHistoryLabel")}
                        </h3>
                    </div>
                </div>
            </div>
            <div className="fxheight hide-overflow">
                <div
                    className={`col-lg-12 ${styles.container}`}
                >
                    <div
                        className={`myle-doc-tb main-content myle-form documents ${styles.content}`}
                    >
                        {props.preventiveCareNotices.map(p => {
                            const providerName = Employee.getFullNameWithPrefixContactFacet(p.EmployeeContactFacetId);
                            const parsedDate = LuxonDateTimeParser.parse(p.GeneratedDate).toLocal();
                            const shouldRemoveTimestamp = parsedDate.hour === 0 && parsedDate.minute === 0 && parsedDate.second === 0;

                            const generationDate = shouldRemoveTimestamp
                                ? parsedDate.toFormat("yyyy/LL/dd")
                                : parsedDate.toFormat(`yyyy/LL/dd '${getText("AtLabel")}' HH:mm:ss a`);

                            return (
                                <CorrespondenceHistoryItem
                                    key={p.Id}
                                    providerName={MyleHelper.ReplaceEmptyString(providerName)}
                                    patientName={NameHelper.formatFullNameForHasPatientName(p)}
                                    preventiveItem={cacheStore.findPreventiveCareCriteria(p.PreventiveCareCriteriaId)?.getTranslatedName()}
                                    notice={getCurrentPreventiveCareNoticeLabel(p.LetterType)}
                                    generationDate={generationDate}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="ws-footer table-pager-footer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-right">
                        <ButtonControl
                            className="btn btn-primary push-right-5"
                            onClick={() => sessionStore.dispatch(LocalOperations.Portfolio.PreventiveRecallList_NavigateBetweenTabs, { currentTab: PreventiveRecallTab.Default })}
                            label={getText("BackLabel")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { CorrespondenceHistory };
